import { render, staticRenderFns } from "./WeekQualityControlList.vue?vue&type=template&id=3d0020ed&scoped=true&"
import script from "./WeekQualityControlList.vue?vue&type=script&lang=js&"
export * from "./WeekQualityControlList.vue?vue&type=script&lang=js&"
import style0 from "./WeekQualityControlList.vue?vue&type=style&index=0&id=3d0020ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0020ed",
  null
  
)

export default component.exports